var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconPdfComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? false : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-Pdf ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("rect", {
    width: "36",
    height: "36",
    rx: "2",
    fill: useCurrentColor ? 'currentColor' : '#DE2134'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33833 23.9183C11.1379 23.7846 12.8708 23.1163 14.2705 21.9133C17.0031 22.5148 19.6025 23.3836 22.2019 24.4529C24.2681 28.1287 26.2009 30 27.8672 30C28.2004 30 28.6003 29.9332 28.8669 29.7327C29.6001 29.3985 30 28.6634 30 27.9282C30 27.3267 29.8667 25.6559 23.5349 22.9158C22.0686 20.2425 20.9355 17.5024 20.0024 14.6286C20.8022 13.0246 22.5351 9.0815 21.3354 7.07653C20.9355 6.34137 20.1357 5.94038 19.2693 6.00721C18.6028 6.00721 17.9363 6.34137 17.5363 6.87603C16.6699 8.07901 16.7365 10.6186 17.8696 14.3612C16.8032 16.3662 15.4035 18.1707 13.7373 19.7078C12.3376 19.4405 10.9379 19.24 9.53828 19.24C6.40571 19.3068 5.93916 20.7771 6.00581 21.646C6.00581 23.9183 8.20527 23.9183 9.33833 23.9183V23.9183ZM28.0005 28.0619L27.8005 27.995C26.8674 27.6609 26.1343 26.9925 25.6011 26.1237C26.6008 26.5247 27.4006 27.193 28.0005 28.0619V28.0619ZM19.136 8.01218H19.3359C19.4026 8.01218 19.5359 8.01218 19.6025 8.07901C19.8691 9.21516 19.6692 10.4181 19.2026 11.4875C18.8027 10.3513 18.8027 9.14833 19.136 8.01218V8.01218ZM18.6694 17.7029L18.7361 17.8365L18.8027 17.7697C19.4026 19.3068 20.0691 20.844 20.8022 22.3143L20.6689 22.2475V22.3811C19.2026 21.8465 17.603 21.3786 16.1367 21.0445L16.2033 20.9776H16.0034C17.0031 19.9752 17.9363 18.839 18.6694 17.7029V17.7029ZM9.60493 21.245C10.2048 21.245 10.738 21.245 11.3378 21.3786C10.6713 21.7128 10.0048 21.8465 9.33833 21.9133C8.87178 21.9801 8.40522 21.9133 8.00532 21.7796C8.00532 21.5791 8.27192 21.245 9.60493 21.245Z",
    fill: useCurrentColor ? 'currentColor' : '#fff'
  }));
}
var IconPdf = /*#__PURE__*/React.forwardRef(IconPdfComponent);
export default IconPdf;